import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

// Action Types
export const REDIRECT_TO_CHARACTER_PAGE = 'REDIRECT_TO_CHARACTER_PAGE';
export const LOAD_ADD_CHARACTER_DATA_FROM_LOCAL_STORAGE = 'LOAD_ADD_CHARACTER_DATA_FROM_LOCAL_STORAGE';
export const SET_ADD_CHARACTER_PARAMS = 'SET_ADD_CHARACTER_PARAMS';
export const TOGGLE_OPEN_CHARACTER_DETAILS_TABLE = 'TOGGLE_OPEN_CHARACTER_DETAILS_TABLE';
export const SET_CHARACTER_DETAILS_TABLE_BOSS_RANKINGS = 'SET_CHARACTER_DETAILS_TABLE_BOSS_RANKINGS';
export const SET_CHARACTER_BOSS_KILL_DETAILS = 'SET_CHARACTER_BOSS_KILL_DETAILS';
export const SET_CHARACTER_DETAILS = 'SET_CHARACTER_DETAILS';
export const SET_CHARACTER_ALTS = 'SET_CHARACTER_ALTS';
export const SET_CHARACTER_MYTHIC_PLUS_RUNS = 'SET_CHARACTER_MYTHIC_PLUS_RUNS';
export const SET_CHARACTER_MYTHIC_PLUS_FILTERS = 'SET_CHARACTER_MYTHIC_PLUS_FILTERS';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';
export const TOGGLE_OPEN_DUNGEON = 'TOGGLE_OPEN_DUNGEON';
export const TOGGLE_CHARACTER_MPLUS_SORT = 'TOGGLE_CHARACTER_MPLUS_SORT';
export const SET_CHARACTER_RAID_PROGRESS_TIER = 'SET_CHARACTER_RAID_PROGRESS_TIER';
export const SET_CHARACTER_RAID_PROGRESS_LOADING = 'SET_CHARACTER_RAID_PROGRESS_LOADING';
export const SET_CHARACTER_LOADOUT_LOADING = 'SET_CHARACTER_LOADOUT_LOADING';
export const SET_CHARACTER_RAID_PROGRESS = 'SET_CHARACTER_RAID_PROGRESS';
export const SET_CHARACTER_MYTHIC_PLUS_SEASON = 'SET_CHARACTER_MYTHIC_PLUS_SEASON';
export const SET_CHARACTER_MYTHIC_PLUS_PROGRESS_LOADING = 'SET_CHARACTER_MYTHIC_PLUS_PROGRESS_LOADING';
export const SET_CHARACTER_MYTHIC_PLUS_PROGRESS = 'SET_CHARACTER_MYTHIC_PLUS_PROGRESS';
export const CLEAR_CHARACTER_MYTHIC_PLUS_PROGRESS = 'CLEAR_CHARACTER_MYTHIC_PLUS_PROGRESS';

export type TAddCharacterParams = {
  region: string;
  realm: string;
  guild: string;
};

export type TRedirectCharacterParams = {
  region: string;
  realm: string;
  character: string;
};

// Action Creator
const CharacterActionCreator = {
  redirectToCharacterPage(characterInfo: TRedirectCharacterParams): TAction<TRedirectCharacterParams> {
    return {
      type: REDIRECT_TO_CHARACTER_PAGE,
      payload: characterInfo
    };
  },

  loadAddCharacterDataFromLocalStorage(): TAction<undefined> {
    return {
      type: LOAD_ADD_CHARACTER_DATA_FROM_LOCAL_STORAGE,
      payload: undefined
    };
  },

  setAddCharacterParams(params: Partial<TAddCharacterParams>): TAction<Partial<TAddCharacterParams>> {
    return {
      type: SET_ADD_CHARACTER_PARAMS,
      payload: params
    };
  },

  toggleOpenCharacterDetailsTable(raid: string, difficulty: string): TAction<any> {
    return {
      type: TOGGLE_OPEN_CHARACTER_DETAILS_TABLE,
      payload: {
        raid,
        difficulty
      }
    };
  },

  setCharacterDetailsTableBossRankings(raid: string, difficulty: string, bossRankings: any[]) {
    return {
      type: SET_CHARACTER_DETAILS_TABLE_BOSS_RANKINGS,
      payload: {
        raid,
        difficulty,
        bossRankings
      }
    };
  },

  setCharacterBossKillDetails(raid: string, boss: string, difficulty: string, details: any) {
    return {
      type: SET_CHARACTER_BOSS_KILL_DETAILS,
      payload: {
        raid,
        boss,
        difficulty,
        details
      }
    };
  },

  setCharacterDetails(details: any) {
    return {
      type: SET_CHARACTER_DETAILS,
      payload: details
    };
  },

  setCharacterAlts(details: any) {
    return {
      type: SET_CHARACTER_ALTS,
      payload: details
    };
  },

  setCharacterMythicPlusSeason(season: any) {
    return {
      type: SET_CHARACTER_MYTHIC_PLUS_SEASON,
      payload: season
    };
  },

  setCharacterRaidProgressTier(tier: string) {
    return {
      type: SET_CHARACTER_RAID_PROGRESS_TIER,
      payload: tier
    };
  },

  setCharacterMythicPlusRuns(details: any) {
    return {
      type: SET_CHARACTER_MYTHIC_PLUS_RUNS,
      payload: details
    };
  },

  setCharacterMythicPlusFilters(details: any) {
    return {
      type: SET_CHARACTER_MYTHIC_PLUS_FILTERS,
      payload: details
    };
  },

  showLoadingSpinner(show: boolean) {
    return {
      type: SHOW_LOADING_SPINNER,
      payload: show
    };
  },

  toggleOpenDungeon(dungeonId: number) {
    return {
      type: TOGGLE_OPEN_DUNGEON,
      payload: dungeonId
    };
  },

  toggleMplusSort(field: string, defaultSortOrder: string) {
    return {
      type: TOGGLE_CHARACTER_MPLUS_SORT,
      payload: {
        field,
        defaultSortOrder
      }
    };
  },

  setCharacterMythicPlusProgressLoading(season: string, loading: boolean) {
    return {
      type: SET_CHARACTER_MYTHIC_PLUS_PROGRESS_LOADING,
      payload: {
        season,
        loading
      }
    };
  },

  setCharacterMythicPlusProgress(payload: any) {
    return {
      type: SET_CHARACTER_MYTHIC_PLUS_PROGRESS,
      payload
    };
  },

  setCharacterRaidProgressLoading(tier: string, loading: boolean) {
    return {
      type: SET_CHARACTER_RAID_PROGRESS_LOADING,
      payload: {
        tier,
        loading
      }
    };
  },

  setCharacterLoadoutLoading(loading: boolean) {
    return {
      type: SET_CHARACTER_LOADOUT_LOADING,
      payload: loading
    };
  },

  setCharacterRaidProgress(payload: any) {
    return {
      type: SET_CHARACTER_RAID_PROGRESS,
      payload
    };
  },

  clearCharacterMythicPlusProgress() {
    return {
      type: CLEAR_CHARACTER_MYTHIC_PLUS_PROGRESS
    };
  }
};

export default CharacterActionCreator;
